
import { defineComponent, onBeforeMount } from 'vue'

import Tabs from '@/common/components/UI/Tabs/index.vue'

// types
import { TabT } from '@/core/types/components.types'

// composable
import useAccount from '@/common/composable/useAccount'

export default defineComponent({
    components: {
        tabs: Tabs,
    },
    setup() {
        const { havePermissions } = useAccount()

        const tabs: TabT[] = [
            { id: 1, name: 'Подписанные', path: '/contracts' },
            { id: 2, name: 'На согласовании', path: '/contracts/to-be-agreed' },
        ]

        const setTabs = () => {
            if (havePermissions(['contract-register-index', 'all-root-permission'])) {
                tabs.splice(1, 0, {
                    id: 3,
                    name: 'Реестр договоров',
                    path: '/contracts/register',
                })
            }

            if (havePermissions(['contract-contract-archive', 'all-root-permission'])) {
                tabs.push({
                    id: 3,
                    name: 'Архив Договор24',
                    path: '/contracts/archive',
                })
            }
        }

        onBeforeMount(setTabs)

        return { tabs }
    },
})
